import { noddiAsync, URLKeys } from 'noddi-async';
import { BookingProposal } from 'noddi-types';
import { ErrorPage, LoadingScreen } from 'noddi-ui-web';
import { PropsWithChildren, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { RouterLayout } from '../../components/Layouts/RouterLayout';
import { BookingProposalContext, BookingProposalStore, createBookingProposalStore } from './bookingProposalStore';

interface BookingProposalProps {
  bookingProposal: BookingProposal;
}

function BookingProposalProvider({ children, ...props }: PropsWithChildren<BookingProposalProps>) {
  const storeRef = useRef<BookingProposalStore>();

  if (!storeRef.current) {
    storeRef.current = createBookingProposalStore({
      address: props.bookingProposal.address,
      bookingProposalItems: props.bookingProposal.bookingProposalItems,
      slug: props.bookingProposal.slug
    });
  }

  return (
    <BookingProposalContext.Provider value={storeRef.current}>
      <RouterLayout />
    </BookingProposalContext.Provider>
  );
}

export const BookingProposalWrapper = () => {
  const { slug } = useParams();

  const {
    data: bookingProposal,
    isPending: isBookingProposalPending,
    error: bookingProposalError
  } = noddiAsync.useGet({
    type: URLKeys.getBookingProposalBySlug,
    input: { slug: slug! }
  });

  if (isBookingProposalPending) {
    return <LoadingScreen />;
  }

  if (bookingProposalError) {
    return <ErrorPage apiError={bookingProposalError} />;
  }

  return <BookingProposalProvider bookingProposal={bookingProposal} />;
};
